export default `
... on entryBlocks_headlineCopy_BlockType {
  baseSubline
  baseHeadlineBig
  baseHeadline
  baseCopy
}
`;
